import React, { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import useAppStore from '../store/useAppStore'
import Loader from './Loader'

/**
 * Компонент для управления редиректом на онбординг
 * Проверяет is_first_visit и перенаправляет пользователя соответственно
 */
const OnboardingRouter = ({ children }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { isFirstVisit, isLoading } = useAppStore(state => ({
    isFirstVisit: state.isFirstVisit,
    isLoading: state.isLoading
  }))

  console.log('🔍 OnboardingRouter render:', {
    isFirstVisit,
    isLoading,
    pathname: location.pathname,
    timestamp: new Date().toISOString()
  })

  useEffect(() => {
    console.log('🔄 OnboardingRouter useEffect triggered:', {
      isFirstVisit,
      isLoading,
      pathname: location.pathname
    })

    // Не делаем редиректы во время загрузки или если статус не определен
    if (isLoading || isFirstVisit === null) {
      console.log('⏸️ Пропускаем редирект:', { isLoading, isFirstVisit, isOnboarding: location.pathname === '/onboarding' })
      return
    }

    // Если это первый визит и пользователь НЕ на онбординге И НЕ на странице приветственного кейса - редиректим на онбординг
    const isWelcomeCasePage = location.pathname.includes('/cases/00000000000000000000000000000000')
    if (isFirstVisit === true && location.pathname !== '/onboarding' && !isWelcomeCasePage) {
      console.log('🎯 Первый визит пользователя - редирект на онбординг')
      navigate('/onboarding', { replace: true })
      return
    }

    // Если пользователь уже прошел онбординг, но находится на странице онбординга
    // редиректим на главную
    if (isFirstVisit === false && location.pathname === '/onboarding') {
      console.log('🏠 Пользователь уже прошел онбординг - редирект на главную')
      navigate('/', { replace: true })
      return
    }

    console.log('✅ Никаких редиректов не требуется')

  }, [isFirstVisit, isLoading, location.pathname, navigate])

  // Показываем лоадер пока определяется статус первого визита
  if (isLoading || isFirstVisit === null) {
    console.log('🔄 Показываем лоадер инициализации:', { isLoading, isFirstVisit })
    return <Loader message="" />
  }

  // Определяем разрешенные страницы для первого визита
  const isWelcomeCasePage = location.pathname.includes('/cases/00000000000000000000000000000000')
  const isOnboardingPage = location.pathname === '/onboarding'
  const isAllowedForFirstVisit = isOnboardingPage || isWelcomeCasePage

  // Если это первый визит и пользователь на разрешенной странице - показываем контент
  if (isFirstVisit === true && isAllowedForFirstVisit) {
    console.log('🎊 Показываем онбординг или приветственный кейс')
    return children
  }

  // Если это первый визит и пользователь НЕ на разрешенной странице - показываем лоадер (происходит редирект)
  if (isFirstVisit === true && !isAllowedForFirstVisit) {
    console.log('🎯 Показываем лоадер редиректа на онбординг')
    return <Loader message="Перенаправление на онбординг..." />
  }

  // Если пользователь уже прошел онбординг и находится на онбординге - показываем лоадер (происходит редирект)
  if (isFirstVisit === false && isOnboardingPage) {
    console.log('🏠 Показываем лоадер редиректа на главную')
    navigate('/', { replace: true })
    return <Loader message="Перенаправление на главную..." />
  }

  // Если пользователь уже прошел онбординг и НЕ на онбординге - показываем обычный контент
  if (isFirstVisit === false && !isOnboardingPage) {
    console.log('✅ Показываем обычный контент:', { isFirstVisit, pathname: location.pathname })
    return children
  }

  // Fallback - показываем лоадер
  console.log('❓ Fallback - показываем лоадер:', { isFirstVisit, pathname: location.pathname })
  return <Loader message="Загрузка..." />
}

export default OnboardingRouter
